import {computed, ComputedRef} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {isString} from "@songfinch/utils/src/validators";
import type {CardData, RecipientFormData} from "@songfinch/shared/types";

interface PageData {
    stepCard?: {
        list?: CardData[]

    }
    relationships?:{
        list?: RecipientFormData[]
    } 
    occasions?: {
        list?: RecipientFormData[]
    }
    [key: string]: unknown;
}

export default function useBsFormChapters() {
    const store = useStore();
    const route = useRoute();

    const CmsData: ComputedRef<PageData> = computed(() => {
        const pageId = route.meta.pageDataKey as string | undefined || route.name as string | undefined;
        if (!isString(pageId)) return {};
        return store.state.cms.pageData?.[pageId] ?? {};
    });

    return {
        CmsData
    };
}
